export default {
  methods: {
    isAppleDevice() {
      const userAgent = navigator.userAgent.toLowerCase();
      const platform = navigator.platform.toLowerCase();

      const isIOS = /iphone|ipad|ipod/.test(userAgent);
      const isMac = /mac/.test(platform) || (navigator.userAgentData && navigator.userAgentData.platform === 'macOS');
      const isAndroid = /android/.test(userAgent);

      // If it's Android, definitely not Apple
      if (isAndroid) {
        return false;
      }

      // If it's iOS or macOS, and not Android spoofing, then it's Apple
      return isIOS || isMac;
    }
  }
};